import * as D from '../../../utils/dbmodel';

export default {
    namespaced: true,
    state: {
        searchP: {},
        list: [], //table中的list显示数据
        pagination: {}, //分页相关的信息
        record: {}, //根据id查询的数据详情信息
    },

    getters: {
        getDomainnameSelectOptions (state) {
            return state.domainnameSelectOptions
        }
    },

    mutations: {
        save (state, action) {
            for (var key in action.payload) {
                state[key] = action.payload[key]
            }
        }
    },

    actions: {
        queryauth (context, payload) {
            return D.select({
                ...payload
            })
        },
        updateauth (context, payload) {
            return D.edit({
                ...payload
            })
        },
        districtManage (context, payload) {
            return D.select({
                ...payload
            })
        },
        //查询App列表信息
        selectOnedoc (context, payload) {
            return D.select({
                ...payload
            })
        },

        deletedoc (context, payload) {
            return D.del({
                ...payload
            })
        },
        adddoc (context, payload) {
            return D.add({
                ...payload
            })
        },
        updatedoc (context, payload) {
            return D.edit({
                ...payload
            })
        },
        selectdoclist (context, payload) {
            return D.select({
                ...payload
            })
        },
        syncselectdoclist (context, payload) {
            return D.syncSelect({
                ...payload
            })
        },
        yapilist (context, payload) {
            return D.select({
                ...payload
            })
        },
        yapidesc (context, payload) {
            return D.select({
                ...payload
            })
        },
        selectOpenUserinfosPage (context, payload) {
            return D.select({
                ...payload
            })
        },
        selectOpenUserinfosOne (context, payload) {
            return D.edit({
                ...payload
            })
        },
        insertOpenUserinfo (context, payload) {
            return D.del({
                ...payload
            })
        },
        updateOpenUserinfo (context, payload) {
            return D.add({
                ...payload
            })
        },
        dispatchQueryPageList (context, payload) {
            return D.select({
                ...payload
            })
        },
        dispatchQuery (context, payload) {
            return D.select({
                ...payload
            })
        },
        dispatchUpdate (context, payload) {
            return D.edit({
                ...payload
            })
        },
        dispatchAdd (context, payload) {
            return D.add({
                ...payload
            })
        },
        dispatchDel (context, payload) {
            return D.del({
                ...payload
            })
        },
        slidervertify (context, payload) {
            return D.select({
                ...payload
            })
        },

        callbackInfospage (context, payload) {
            return D.select({
                ...payload
            })
        },

        callbackAppManagePage (context, payload) {
            return D.select({
                ...payload
            })
        },

        callbackAppManageAdd (context, payload) {
            return D.add({
                ...payload
            })
        },

        callbackAppManageDel (context, payload) {
            return D.del({
                ...payload
            })
        },

        callbackAppManageEdit (context, payload) {
            return D.edit({
                ...payload
            })
        },

        callbackAppManageDetail (context, payload) {
            return D.select({
                ...payload
            })
        },

        callbackAppManageAddTopic (context, payload) {
            return D.add({
                ...payload
            })
        },

        callbackAppManageDelTopic (context, payload) {
            return D.del({
                ...payload
            })
        },

        shortLinkAdd (context, payload) {
            return D.add({
                ...payload
            })
        },

        shortLinkDel (context, payload) {
            return D.del({
                ...payload
            })
        },

        shortLinkPage (context, payload) {
            return D.select({
                ...payload
            })
        },
        callbackAppManageQueryTopics (context, payload) {
            return D.select({
                ...payload
            })
        },

        shortLinkTypeAdd (context, payload) {
            return D.add({
                ...payload
            })
        },

        shortLinkTypeDel (context, payload) {
            return D.del({
                ...payload
            })
        },

        shortLinkTypeEdit (context, payload) {
            return D.edit({
                ...payload
            })
        },

        shortLinkTypeDetail (context, payload) {
            return D.select({
                ...payload
            })
        },

        shortLinkTypePage (context, payload) {
            return D.select({
                ...payload
            })
        },

        queryShortLink (context, payload) {
            return D.select({
                ...payload
            })
        },

    }
}
